// AUTO-GENERATED by scripts/build-icons.js. Do not edit by hand.
// Lists every icon glyph that can be fetched from icons/<name>.svg.
const ICONS = [
  "align-center",
  "align-indent",
  "align-justify",
  "align-left",
  "align-outdent",
  "align-right",
  "align",
  "arrow-circle-down",
  "arrow-circle-left",
  "arrow-circle-right",
  "arrow-circle-up",
  "arrows-alt",
  "arrows-h",
  "arrows-v",
  "bold",
  "caret",
  "chain-broken",
  "circle",
  "close",
  "code",
  "col-after",
  "col-before",
  "col-remove",
  "eraser",
  "float-left",
  "float-none",
  "float-right",
  "font",
  "frame",
  "italic",
  "link",
  "magic",
  "menu-check",
  "minus",
  "orderedlist",
  "pencil",
  "picture",
  "question",
  "redo",
  "rollback",
  "row-above",
  "row-below",
  "row-remove",
  "special-character",
  "square",
  "strikethrough",
  "subscript",
  "summernote",
  "superscript",
  "table",
  "text-height",
  "trash",
  "underline",
  "undo",
  "unorderedlist",
  "video",
];

export default ICONS;
export const ICON_COUNT = ICONS.length;
